<template>
  <section class="content-block small-padding">
    <transition name="slide-fade-delay">
      <div
        v-if="active"
        class="block has-white-background"
      >
        <div class="inner-block is-flex">
          <div class="title-container">
            <h1 class="title">
              {{ $t("fahrtView.label.amountOfGuests") }}
            </h1>
            <InctInfoElement>
              <p
                class="subtitle"
                v-html="$t(`fahrtView.label.tooltip`)"
              />
            </InctInfoElement>
          </div>
          <div class="select-extended is-flex">
            <div class="select">
              <select v-model="ticket_reservation">
                <option
                  value="0"
                  disabled
                  selected
                >
                  0
                </option>
                <option
                  v-for="option in this.$store.state.fetch_GET_Configuration.maxCapacityPerReservation"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
            </div>

            <div class="select-info">
              <h1 class="title">
                {{ $t("fahrtView.label.totalAmount") }}
              </h1>
              <p class="subtitle no-margin">
                {{ $t("fahrtView.label.totalAmountHint") }}
              </p>
              <p
                class="subtitle no-margin"
                v-if="$store.state.fahrttyp === 'ascent'"
              >
                {{ $t("fahrtView.label.childrenHint") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import {liveURL} from '../../api-config';
import axios from 'axios'
import InctInfoElement from "@/components/info-element/InctInfoElement.vue";

export default {
  name: 'AnzahlReservierung',
  components: {InctInfoElement},
  data() {
    return {
      active: false
    }
  },
  computed: {
    ticket_reservation: {
      get() {
        return this.$store.state.ticket_reservation_amount
      },
      set(value) {
        this.$store.state.ticket_reservation_amount = value
      }
    }
  },
  mounted() {
    this.active = true
    this.fetch_GET_Configuration_Fn()
  },
  methods: {
    fetch_GET_Configuration_Fn() {
      this.$store.state.fetch_GET_Configuration.maxCapacityPerReservation = 10

      axios.get(liveURL + '/api/ticket/slot/getConfiguration/', {})
        .then(function (response) {
          this.$store.state.fetch_GET_Configuration = response.data
        }.bind(this)).catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-extended {
  width: 100%;
  display: block;
  position: relative;
  margin-top: 0.9rem;

  .select-info,
  .select-pricing {
    padding-top: 0.42rem;
    padding-left: 0.6rem;
  }

  .select-pricing {
    text-align: right;
    margin-left: auto;
    display: block;
    min-width: 65px;
  }

  .title {
    text-transform: none;
    margin-bottom: 0rem;
  }
}

.inner-block.is-flex {
  flex-direction: column;
}

.select-extended-sum {
  border-top: 1px solid rgb(200, 200, 200);
  padding-top: 1.2rem;
  margin-top: 0rem;

  .title {
    text-transform: none;
    margin-bottom: 0rem;
  }
}

.price-info {
  cursor: pointer;
}

.no-margin {
  margin-bottom: 0 !important;
}

.align-right {
  text-align: right;
}
</style>
